import { createAccountStorageFlag } from 'src/modules/brand/utils/account-storage-flag'

const dismissedFlag = createAccountStorageFlag('smsr-kalama-renamed-dismissed')

export function isKalamaRenamedBannerDismissed(accountId: string): boolean {
  return dismissedFlag.read(accountId)
}

export function dismissKalamaRenamedBanner(accountId: string): void {
  dismissedFlag.write(accountId)
}
